<template>
  <div class="html-content inline" v-html="processedHtml" @click="handleClick"></div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'HtmlToVue',
  props: ['html'],
  data() {
    return {
      router: useRouter(),
    };
  },
  computed: {
    processedHtml() {
      if (!this.html) return '';

      // Mark internal links (href starting with '/') for router navigation
      return this.html.replace(/<a\s+([^>]*href=["']\/[^"']*["'][^>]*)>/gi, (match, attrs) => {
        // Remove target attribute and add data-internal-link marker
        const cleanedAttrs = attrs.replace(/\s+target=["'][^"']*["']/gi, '');
        return `<a ${cleanedAttrs} data-internal-link="true">`;
      });
    },
  },
  methods: {
    handleClick(event) {
      // closest() handles both direct link clicks and nested element clicks
      const link = event.target.closest('a[data-internal-link]');
      if (link) {
        event.preventDefault();
        const href = link.getAttribute('href');
        if (href) {
          this.router.push(href);
        }
      }
    },
  },
};
</script>

<style scoped>
.html-content {
  display: inline;
}

.html-content :deep(img) {
  max-width: 100%;
  height: auto;
}

/* Preserve inline styles for emojis */
.html-content :deep(span[data-type='emoji']) {
  display: inline-block;
  white-space: nowrap;
}

.html-content :deep(span[data-type='emoji'] img) {
  display: inline;
  vertical-align: middle;
  max-width: 1.2em;
  max-height: 1.2em;
}
</style>
